// Central SDK entry — one import for your whole API.
// Usage: const api = createSalesSDK({ baseURL, wsURL })

import { createConfig } from "./apiBase/config.js";
import { HttpClient } from "./apiBase/httpClient.js";

import { DevicesAPI } from "./devices.js";
import { SetupAPI } from "./setUp.js";
import { TranscriptionWS } from "./transcription.js";
import { SalesAPI } from "./sales.js";
import { MetaAPI } from "./meta.js";
import { CostAPI } from "./costs.js";
import { DebugAPI } from "./debug.js";

/**
 * Create a fully-wired SDK instance.
 * @param {{baseURL?: string, wsURL?: string, defaultHeaders?: Record<string,string>}} [opts]
 */
export const createSalesSDK = (opts = {}) => {
  const cfg = createConfig({
    baseURL: opts.baseURL ?? (window.location.protocol === 'https:' ? "https://localhost:8080" : "http://localhost:8080"),
    wsURL: opts.wsURL ?? (window.location.protocol === 'https:' ? "wss://localhost:8080" : "ws://localhost:8080"),
    defaultHeaders: opts.defaultHeaders,
  });

  const http = new HttpClient(cfg);

  return {
    // low-level (optional)
    _cfg: cfg,
    _http: http,

    // feature APIs
    devices: new DevicesAPI(http, { wsURL: cfg.wsURL }),
    setup: new SetupAPI(http),
    transcription: new TranscriptionWS({ wsURL: cfg.wsURL }),
    sales: new SalesAPI(http, { wsURL: cfg.wsURL }),
    meta: new MetaAPI(http),
    costs: new CostAPI(http),
    debug: new DebugAPI(http),
  };
};

// Optional re-exports if you want advanced/custom wiring elsewhere:
export {
  createConfig,
  HttpClient,
  DevicesAPI,
  SetupAPI,
  TranscriptionWS,
  SalesAPI,
  MetaAPI,
  CostAPI,
  DebugAPI,
};
